export class FormasFilter {
    formasName
    filterType = 'formas'
    constructor(formasName) {
        this.formasName = formasName
    }

    apply(products) {
        return products.filter(product => {
            return (product.Forma.toLowerCase().trim() === this.formasName.toLowerCase().trim())
        })
    }
}